import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlHelper {
  public apiUrl = {
    login:{
      LoginUser: 'admin/account/login',
      Logout:'admin/account/logout'
    },
    forgotPassword: {
      ForgetPassword:'admin/account/forget-password',
      ResetPassword:'admin/account/reset-password',
      ChangePassword:'admin/profile/change-password',
    },
    verificationOTP:{
      verificationOTP:'admin/account/verification-code'
    },
    college: {
      GetCollegeList: 'admin/college/list',
      GetCollegeListForDropDown: 'admin/college/list',
      SaveCollege: 'admin/college/save',
      DeleteCollege: 'admin/college/delete/{id}',
      InActiveCollege:'admin/college/active-inactive/{id}',
      GetCollegeById:'admin/college/{id}',
      GetCollegeListForExam: 'admin/college/collegelist'
    },
    student:{
      GetStudentList: 'admin/student/list',
      UploadFile: 'admin/student/import-excel',
      ActiveInactive: 'admin/student/active-inactive/{id}',
      // GetStudentById:'admin/student/{id}',
      SaveStudent:'admin/student/save',
      ExportStudent:'admin/student/export-excel',
      ExportPdf :'admin/student/export-pdf',
      Template: 'StudentExcel/UploadExcel.xlsx',
      GetStudentById: 'admin/student/{id}',
      DeleteStudent:'admin/student/delete/{id}'
    },
    collageBatch:{
      GetCollegeBatchList:'admin/batch/list',
      SaveCollegeBatch: 'admin/batch/save',
      DeleteCollegeBatch: 'admin/batch/delete/{id}',
      ActiveCollegeBatch:'admin/batch/active-inactive/{id}',
      GetCollegeByIdBatch:'admin/batch/{id}',
      GetBatchByCollegeId:'admin/batch/list/{id}',
      GetCollegeBatchListWithStudent:'admin/batch/batch-list/{id}',
      GetCollegeBatchListByCollegeIdAndCompanyId: 'admin/batch/college-batch-list/{id}'
    },
    QuestionSet:{
      GetList:'admin/question-set/list',
      GetQuestionSetById:'admin/question-set/{id}',
      SaveQuestionSet:'admin/question-set/save',
      ActiveQuestionSet:'admin/question-set/active-inactive/{id}',
      DeleteQuestionSet:'admin/question-set/delete/{id}'
    },
    Profile:{
      EditProfile:'admin/profile/edit',
      GetProfile:'admin/profile/profile/{id}'
    },
    test:{
      GetTestList: 'admin/exam/list',
      SaveTest: 'admin/exam/save',
      DeleteTest: 'admin/exam/delete/{id}',
      LiveTest: 'admin/exam/Live/{id}',
      ViewTest: 'admin/exam/View/{id}',
      GetTestById:'admin/exam/{id}',
      DeleteQuestionSet:'admin/question-set/delete/{id}',
      GetQuestionSetList:'admin/question-set/list',
      GetQuestionSetListWithOutCount: 'admin/question-set/listwithoutcount',
      GetTestResultById:'admin/exam-result/list',
      GetTestPendingStudentById : 'admin/exam-result/pending-student',
      ExportTestResultById:'admin/exam-result/export-result',
      ExportPendingStudentById:'admin/exam-result/pending-student-export/{examId}',
      StudentTestResult:'admin/exam-result/detail/{id}',
      TestCollegeBatchDetailsById:'admin/exam/college-batch-details/{examId}',
      RestartTest : 'admin/exam/restart-exam',
      DeleteStudentResult: 'admin/exam/delete-student-result/{id}',
      EditTestData: 'admin/exam/detail/{examId}',
      ExportPdf: 'admin/exam-result/export-pdf/{id}',
      ExamStudentList:'admin/exam/exam-student-list'
    },
    question:{
      GetQuestionList:'admin/question/list',
      SaveQuestion: 'admin/question/save',
      DeleteQuestion: 'admin/question/{id}',
      UpdateQuestion:'admin/question',
      GetQuestionById:'admin/question/{id}',
      GetParagraphById : 'admin/question/paragraph-question-list/{id}',
      DeleteParagraphId : 'admin/question/deleteparagraph/{id}',
      GetQuestionTypes:'admin/question/question-type/list',
      InActiveQuestion:'admin/question/active-inactive/{id}',
      SaveMultiple:'admin/question/saveMultiple',
      UploadQuestion: 'admin/question/import-excel',
      Template:'QuestionExcel/UploadExcel.xlsx'
    },
    user:{
      GetUserList:'admin/user/list',
      ActiveUser:'admin/user/active-inactive/{id}',
      DeleteUser: 'admin/user/delete/{id}',
      SaveUser:'admin/user/save',
      AdminRoleList:'admin/user/role/list',
     CompanyRoleList:'admin/user/company-role/list',
      GetUserById:'admin/user/{id}',
    },
    reportProblem:{
      GetReportProblemList:'admin/report-problem/list',
      GetReportProblemById:'admin/report-problem/{id}'
    },
    company:{
      GetCompanyList:'admin/company/list',
      ActiveCompany:'admin/company/active-inactive/{id}',
      DeleteCompany: 'admin/company/delete/{id}',
      SaveCompany:'admin/company/save',
      GetCompanyById:'admin/company/{id}',
    },
    companyUser:{
      GetCompanyUserList:'admin/company/user/list',
      ActiveCompanyUser:'admin/company/user/active-inactive/{id}',
      DeleteCompanyUser: 'admin/company/user/delete/{id}',
      SaveCompanyUser:'admin/company/user/save',
      GetCompanyById:'admin/company/user/{id}',
      GetCompanyList:'admin/company/user/company/list',
    },
    job:{
      ActiveJob:'admin/job/active-inactive-job/{id}',
      GetJobList:'admin/job/list',
      GetJobTypeList:'admin/job/jobtype',
      DeleteJob:'admin/job/delete/{id}',
      AppliedJobList:'admin/job/appliedlist',
      ExportToExcel:'admin/job/exporttoexcel',
      AppliedJob:'admin/job/appliedjob/{jobapplyid}',
      GetParentTechnologyPreferenceList:'admin/job/get-technology-preference-list',
      SaveJob:'admin/job/save',
      GetJobDetail:'admin/job/{id}',
      GetStateList:'admin/job/state/list',
      GetCityByStateId:'admin/job/city/{stateId}',
      ExportPDF : 'admin/job/export-pdf'
    },
    ParentTechnologyPreferences:{
      SaveTechnologyPreference:'admin/technologypreference/save',
      GetParentTechnologyPreferenceList:'admin/technologypreference/parentlist',
      // GetChildTechnologyPreferenceList:'admin/technologypreference/childlist/{id}',
      ActiveParentTechnologyPreference:'admin/technologypreference/active-inactive-parent/{id}',
      TechnlogyPreferenceById:'admin/technologypreference/get-technology-by-id/{id}',
      DeleteTechnlogyPreference: 'admin/technologypreference/delete-technology/{id}',
    },
    ChildTechnologyPreferences:{
      SaveTechnologyPreference:'admin/technologypreference/save',
      GetChildTechnologyPreferenceList:'admin/technologypreference/childlist',
      ActiveChildTechnologyPreference:'admin/technologypreference/active-inactive-child/{id}',
      TechnlogyPreferenceById:'admin/technologypreference/get-technology-by-id/{id}',
      DeleteTechnlogyPreference: 'admin/technologypreference/delete-technology/{id}',
    }
  };
}
